import React, { useEffect } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import FeedbackAgentWisePage from "../pages/Agent/FeedbackAgentWisePage.jsx";
import BookingComments from "../pages/Agent/BookingComments.jsx";

import AgentLeads from "../pages/Agent/AgentLead.jsx";
import AppLayout from "../components/header.jsx";

// Pages
// import AttendanceHistory from "../pages/AttendanceHistory.jsx";
import Dashboard from "../pages/Dashboard.jsx";
import DriverAttendancePage from "../pages/DriverAttendancePage.jsx";
import DriverAttendancePageDaily from "../pages/DriverAttendancePageDaily.jsx";

import ConfirmationhecklistPage from "../pages/ConfirmationhecklistPage.jsx";
import ConfirmationhecklistAddPage from "../pages/ConfirmationhecklistAddPage.jsx";

import FeedbackcategorylistPage from "../pages/FeedbackcategorylistPage.jsx";
import FeedbackcategorylistAddPage from "../pages/FeedbackcategorylistAddPage.jsx";

import FeedbackSubcategoryListPage from "../pages/FeedbackSubcategoryListPage.jsx";
import FeedbackSubcategoryAddPage from "../pages/FeedbackSubcategoryAddPage.jsx";

import DriverLoginStatusPage from "../pages/DriverLoginStatusPage.jsx";
import DriverExpences from "../pages/Driverexpences.jsx";
import OtherExpenses from "../pages/OtherExpenses.jsx";

import DriverSalaryPage from "../pages/DriverSalaryPage.jsx";
import PrepareSalaryPage from "../pages/PrepareSalaryPage.jsx";
import ConfirmSalaryPage from "../pages/ConfirmSalaryPage.jsx";
import SalarySlipPage from "../pages/SalarySlipPage.jsx";
import SalarySlipSinglePage from "../pages/SalarySlipSinglePage.jsx";
import SosPage from "../pages/sos.jsx";
import DrvLiveTracker from "../pages/LiveMapPage.jsx";
import DriverTrackingPage from "../pages/DriverTrackingPage.jsx";
import SessionPage from "../pages/SessionPage.jsx";
import MyTrips from "../pages/MyTrips";

import CustomerFeedbackPage from "../pages/customer/Feedbacks.jsx";

// PAGE AREA START//
import PageManage from "../pages/allPage/PageManage.jsx";
import CotactManage from "../pages/allPage/CotactManage.jsx";
import VisaAssistanceManagePage from "../pages/allPage/VisaAssistanceManage.jsx";
// PAGE AREA END//

// CATEGORY AREA START//
import CategoryManage from "../pages/category/CategoryManage.jsx";
import CategoryAdd from "../pages/category/CategoryAdd.jsx";
import CategoryEdit from "../pages/category/CategoryEdit.jsx";
// CATEGORY AREA END//

// TAGS AREA START//
import TagsManage from "../pages/tags/TagsManage.jsx";
import TagsAdd from "../pages/tags/TagsAdd.jsx";
import TagsEdit from "../pages/tags/TagsEdit.jsx";
// TAGS AREA END//

// BLOG AREA START//
import BlogManage from "../pages/blogs/BlogManage.jsx";
import BlogAdd from "../pages/blogs/BlogAdd.jsx";
import BlogDetails from "../pages/blogs/BlogDetails.jsx";
import BlogEdit from "../pages/blogs/BlogEdit.jsx";
// BLOG AREA END//

// VISA ASSISTANCE AREA START//
import VisaAssistanceManage from "../pages/VisaAssistance/VisaAssistanceManage.jsx";
import VisaAssistanceAdd from "../pages/VisaAssistance/VisaAssistanceAdd.jsx";
import VisaAssistanceDetails from "../pages/VisaAssistance/VisaAssistanceDetails.jsx";
import VisaAssistanceEdit from "../pages/VisaAssistance/VisaAssistanceEdit.jsx";
// VISA ASSISTANCE AREA END//

// COUNTRY AREA START//
import CountryManage from "../pages/country/CountryManage.jsx";
import CountryAdd from "../pages/country/CountryAdd.jsx";
import CountryEdit from "../pages/country/CountryEdit.jsx";
// COUNTRY AREA END//

// TAB AREA START//
import TabManage from "../pages/tab/TabManage.jsx";
import TabAdd from "../pages/tab/TabAdd.jsx";
import TabEdit from "../pages/tab/TabEdit.jsx";
// TAB AREA END//


// CITY AREA START//
import CityNameManage from "../pages/city/CityNameManage.jsx";
import CityNameAdd from "../pages/city/CityNameAdd.jsx";
import CityNameEdit from "../pages/city/CityNameEdit.jsx";
// CITY AREA END//


// COUNTRY CITY AREA START//
import CountryCityManage from "../pages/country-city/CountryCityManage.jsx";
import CountryCityAdd from "../pages/country-city/CountryCityAdd.jsx";
import CountryCityEdit from "../pages/country-city/CountryCityEdit.jsx";
// COUNTRY CITY AREA END//

// import Groupname from "../pages/MasterGroupName.jsx";
// Components
import PrivateRoute from "../components/PrivateRoute.jsx";
 
  
// HOLIODAY AREA START//
import PackagesManage from "../pages/holidays/packages/PackagesManage.jsx";
import AddPackagesName from "../pages/holidays/packages/AddPackagesName.jsx";
import PackagesNameEdit from "../pages/holidays/packages/PackagesNameEdit.jsx";
import HolidaysCountryManage from "../pages/holidays/country/HolidaysCountryManage.jsx";
import HolidaysCountryAdd from "../pages/holidays/country/HolidaysCountryAdd.jsx";
import HolidaysCountryEdit from "../pages/holidays/country/HolidaysCountryEdit.jsx";

import HolidaysStateManage from "../pages/holidays/state/HolidaysStateManage.jsx";
import HolidaysStateAdd from "../pages/holidays/state/HolidaysStateAdd.jsx";
import HolidaysStateEdit from "../pages/holidays/state/HolidaysStateEdit.jsx";

import HolidaysCityManage from "../pages/holidays/city/HolidaysCityManage.jsx";
import HolidaysCityAdd from "../pages/holidays/city/HolidaysCityAdd.jsx";
import HolidaysCityEdit from "../pages/holidays/city/HolidaysCityEdit.jsx";

import HolidayPackagesHome from "../pages/holidays/allPage/HolidayPackagesHome.jsx";

import HolidaysTabManage from "../pages/holidays/tabs/HolidaysTabManage.jsx";
import HolidaysTabAdd from "../pages/holidays/tabs/HolidaysTabAdd.jsx";
import HolidaysTabEdit from "../pages/holidays/tabs/HolidaysTabEdit.jsx";

import HolidaysDurationManage from "../pages/holidays/duration/HolidaysDurationManage.jsx";
import HolidaysDurationAdd from "../pages/holidays/duration/HolidaysDurationAdd.jsx";

import HolidaysServicesManage from "../pages/holidays/services_included/HolidaysServicesManage.jsx";
import HolidaysServicesAdd from "../pages/holidays/services_included/HolidaysServicesAdd.jsx";

import HolidayPackagesManage from "../pages/holidays/holiday_packages/HolidayPackagesManage.jsx";
import HolidayPackagesAdd from "../pages/holidays/holiday_packages/HolidayPackagesAdd.jsx";
import HolidayPackagesDetails from "../pages/holidays/holiday_packages/HolidayPackagesDetails.jsx";
import HolidayPackagesEdit from "../pages/holidays/holiday_packages/HolidayPackagesEdit.jsx";

// HOLIODAY AREA END//
import UploadInvoice from "../pages/Agent/UploadInvoice.jsx";
//Feedback


const AppRoutes = () => {
  const handleLogout = () => {
    localStorage.clear();
    window.location.href = "https://www.patratravels.com/admin/home.php";
  };

  return (
    <Routes>
      {/* <Route path="/" element={<RedirectToPHP />} /> */}{" "}
      {/* #########need in live ########### */}
      {/* 🟢 PUBLIC ROUTES (No Login or JWT required) */}
      <Route path="/session-set" element={<SessionPage />} />
      <Route path="/driver-tracking-map" element={<DrvLiveTracker />} />
      {/* 🔒 PROTECTED ROUTES (Requires Admin Login) */}
      <Route
        element={
          <PrivateRoute>
            <AppLayout handleLogout={handleLogout} />
          </PrivateRoute>
        }
      >
        <Route index element={<Navigate to="/dashboard" replace />} />

        <Route path="/dashboard" element={<Dashboard />} />
        <Route
          path="/driverAttendance/monthly"
          element={<DriverAttendancePage />}
        />
        <Route
          path="/driverAttendance/daily"
          element={<DriverAttendancePageDaily />}
        />

        {/* ===== Confirmation Checklist ===== */}
        <Route
          path="/master/confirmation-checklist"
          element={<ConfirmationhecklistPage />}
        />
        <Route
          path="/master/confirmation-checklist/add"
          element={<ConfirmationhecklistAddPage />}
        />

        {/* ===== Salary Deduct (same component) ===== */}
        <Route
          path="/master/salary-ddt-checklist"
          element={<ConfirmationhecklistPage />}
        />
        <Route
          path="/master/salary-ddt-checklist/add"
          element={<ConfirmationhecklistAddPage />}
        />

        {/* ===== Feedback Category ===== */}
        <Route
          path="/master/feedback-categorylist"
          element={<FeedbackcategorylistPage />}
        />
        <Route
          path="/master/feedback-category-add"
          element={<FeedbackcategorylistAddPage />}
        />

        {/* ===== Feedback Sub Category ===== */}
        <Route
          path="/master/feedback-subcategory"
          element={<FeedbackSubcategoryListPage />}
        />
        <Route
          path="/master/feedback-subcategory-add"
          element={<FeedbackSubcategoryAddPage />}
        />

        <Route
          path="/driver-login-status"
          element={<DriverLoginStatusPage />}
        />
        <Route path="/driver-refuel" element={<DriverExpences />} />
        <Route path="/other-expenses" element={<OtherExpenses />} />
        <Route path="/salary/driver-salary" element={<DriverSalaryPage />} />
        <Route path="/salary/prepare" element={<PrepareSalaryPage />} />
        <Route
          path="/salary/prepare/:month/:year"
          element={<PrepareSalaryPage />}
        />
        <Route path="/salary/confirm-salary" element={<ConfirmSalaryPage />} />
        <Route
          path="/salary/confirm-salary/:month/:year"
          element={<ConfirmSalaryPage />}
        />
        <Route path="/salary/salary-slip" element={<SalarySlipPage />} />
        <Route
          path="/salary/salary-slip/:month/:year"
          element={<SalarySlipPage />}
        />
        <Route
          path="/salary/salary-slip-details/:reg/:month/:year"
          element={<SalarySlipSinglePage />}
        />
        <Route path="/sos" element={<SosPage />} />
        <Route path="/driver-tracking" element={<DriverTrackingPage />} />
        <Route path="/my-trips" element={<MyTrips />} />

        {/* Customer Feedback Route */}
        <Route path="/customer/feedbacks" element={<CustomerFeedbackPage />} />

        {/* PAGE ARAE START */}
        <Route path="/page/blog-page-manage" element={<PageManage />} />
        <Route path="/page/manage-contact" element={<CotactManage />} />
        <Route path="/page/visa-assistance-page-manage" element={<VisaAssistanceManagePage />} />
        {/* PAGE AREA END */}
        {/* CATEGORY AREA START */}
        <Route path="/category/manage-category" element={<CategoryManage />} />
        <Route path="/category/add-category" element={<CategoryAdd />} />
        <Route
          path="/category/edit-category/:catId"
          element={<CategoryEdit />}
        />
        {/* CATEGORY AREA START */}

        {/* TAGS AREA START */}
        <Route path="/tags/manage-tags" element={<TagsManage />} />
        <Route path="/tags/add-tags" element={<TagsAdd />} />
        <Route path="/tags/edit-tags/:tagsId" element={<TagsEdit />} />
        {/* TAGS AREA START */}

        
                  {/* CITY AREA START */}
                    <Route path="/city/manage-city-name" element={<CityNameManage />} />
                    <Route path="/city/add-city-name" element={<CityNameAdd />} />
                    <Route path="/city/edit-city-name/:cityId" element={<CityNameEdit />} />
                  {/* CITY AREA START */}

                   {/* COUNTRY CITY AREA START */}
                              <Route path="/country-city/manage-country-city-name" element={<CountryCityManage />} />
                              <Route path="/country-city/add-country-city-name" element={<CountryCityAdd />} />
                              <Route path="/country-city/edit-country-city/:countryCityId" element={<CountryCityEdit />} />
                            {/* COUNTRY CITY AREA START */}

        {/* BLOG AREA START */}
        <Route path="/blog-manage" element={<BlogManage />} />
        <Route path="/add-blog" element={<BlogAdd />} />
        <Route path="/blog-details/:pageID" element={<BlogDetails />} />
        <Route path="/edit-blog/:pageID" element={<BlogEdit />} />
        {/* BLOG AREA END */}

        {/* VISA ASSISTANCE AREA START */}
        <Route
          path="/visa-assistance-manage"
          element={<VisaAssistanceManage />}
        />
        <Route path="/add-visa-assistance" element={<VisaAssistanceAdd />} />
        <Route
          path="/visa-assistance-details/:pageID"
          element={<VisaAssistanceDetails />}
        />
        <Route
          path="/edit-visa-assistance/:pageID"
          element={<VisaAssistanceEdit />}
        />
        {/* VISA ASSISTANCE AREA END */}

        {/* TAB AREA START */}
        <Route path="/tab/manage-tab" element={<TabManage />} />
        <Route path="/tab/add-tab" element={<TabAdd />} />
        <Route path="/tab/edit-tab/:tabId" element={<TabEdit />} />
        {/* TAB AREA START */}

        {/* COUNTRY AREA START */}
        <Route path="/country/manage-country" element={<CountryManage />} />
        <Route path="/country/add-country" element={<CountryAdd />} />
        <Route
          path="/country/edit-country/:countryId"
          element={<CountryEdit />}
        />
        {/* COUNTRY AREA START */}

          {/* HOLIDAYS AREA START */}
        <Route path="/holidays/packages/manage-packages" element={<PackagesManage />} />
        <Route path="/holidays/packages/add-packages-name" element={<AddPackagesName />} />
        <Route path="/holidays/packages/edit-packages-name/:packagesId" element={<PackagesNameEdit />} />
        <Route path="/holidays/country/manage-country" element={<HolidaysCountryManage />} />
        <Route path="/holidays/country/add-country" element={<HolidaysCountryAdd />} />
        <Route path="/holidays/country/edit-country/:countryId" element={<HolidaysCountryEdit />} />
        <Route path="/holidays/state/manage-state" element={<HolidaysStateManage />} />
        <Route path="/holidays/state/add-state" element={<HolidaysStateAdd />} />
        <Route path="/holidays/state/edit-state/:stateId" element={<HolidaysStateEdit />} />

        <Route path="/holidays/city/manage-city" element={<HolidaysCityManage />} />
        <Route path="/holidays/city/add-city" element={<HolidaysCityAdd />} />
        <Route path="/holidays/city/edit-city/:cityId" element={<HolidaysCityEdit />} />


        <Route path="/holidays/tabs/manage-tabs" element={<HolidaysTabManage />} />
        <Route path="/holidays/tabs/add-tabs" element={<HolidaysTabAdd />} />
        <Route path="/holidays/tabs/edit-tabs/:tabId" element={<HolidaysTabEdit />} />

        <Route path="/holidays/duration/manage-duration" element={<HolidaysDurationManage />} />
        <Route path="/holidays/duration/add-duration" element={<HolidaysDurationAdd />} />

        <Route path="/holidays/services-included/manage-services-included" element={<HolidaysServicesManage />} />
        <Route path="/holidays/services-included/add-services-included" element={<HolidaysServicesAdd />} />

        <Route path="/holidays/holiday-packages-home-page" element={<HolidayPackagesHome />} />

         <Route path="/holidays/holiday-packages-manage" element={<HolidayPackagesManage />} />
         <Route path="/holidays/holiday-packages-add" element={<HolidayPackagesAdd />} />
         <Route path="/holidays/holiday-packages-details/:packagesId" element={<HolidayPackagesDetails />} />
        <Route path="/holidays/holiday-packages-edit/:packagesId" element={<HolidayPackagesEdit />} />
        {/* HOLIDAYS AREA END */}
        {/* Feedback Agent Wise Page */}
        <Route path="/feedback/agent-wise" element={<FeedbackAgentWisePage />} />
         <Route path="/comment/agent-wise" element={<BookingComments />} />
         <Route path="/leads/agent-wise" element={<AgentLeads />} />
          <Route path="/endtrips/upload-invoice" element={<UploadInvoice />} />
      </Route>
      {/* ---------- 404 ---------- */}
      <Route
        path="*"
        element={<h1 style={notFoundStyle}>404 - Page Not Found</h1>}
      />
    </Routes>
  );
};

const notFoundStyle = {
  textAlign: "center",
  marginTop: "50px",
  color: "white",
  fontFamily: "Inter, sans-serif",
};

export default AppRoutes;